import { enableHMRForChain } from "@husky-hrc/Utilities/Utilities";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { del } from "@insite/client-framework/Services/ApiService";
import { DeleteWishListLineApiParameter } from "@insite/client-framework/Services/WishListService";
import {
    chain,
    RequestRemoveWishListLine,
} from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/DeleteWishListLine";

enableHMRForChain(chain);

const wishListUrl = "/api/v1/wishlists";

type deleteWishListLineProps = Parameters<typeof RequestRemoveWishListLine>[0];

export const HuskyRequestRemoveWishListLine = async (props: deleteWishListLineProps) => {
    await deleteWishListLineApi({
        wishListId: props.parameter.wishListId,
        wishListLineId: props.parameter.wishListLineId,
        fromCartId: (props.parameter as any).fromCartId,
    } as any);
};

export function deleteWishListLineApi(parameter: DeleteWishListLineApiParameter) {
    return del(
        `${wishListUrl}/${parameter.wishListId}/wishlistlines/${parameter.wishListLineId}?fromCartId=${
            (parameter as any).fromCartId
        }`,
    );
}

replaceInChain(chain, RequestRemoveWishListLine, HuskyRequestRemoveWishListLine);
